import { Injectable, inject } from '@angular/core'
import { type ActivatedRouteSnapshot, Router, type RouterStateSnapshot } from '@angular/router'
import { DqMetadataStore } from '../services/dq-metadata.store'
import { HubAuthStore } from '@inside-hub-app/hub-authentication'
import { HubConfigurationService } from '@inside-hub-app/hub-configuration'

@Injectable({
  providedIn: 'root'
})
export class DataQualityGuard {
  private readonly router = inject(Router)
  private readonly dqMetadataStore = inject(DqMetadataStore)
  private readonly hubAuthStore = inject(HubAuthStore)
  private readonly hubConfigurationService = inject(HubConfigurationService)

  async canActivate (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
    const isDataQualityEnabled = this.hubConfigurationService.get<boolean>('modules.partner-profile.features.enableDataQuality') || false
    const items = this.dqMetadataStore.items()
    const isImpersonateMode = await this.hubAuthStore.isImpersonateMode()

    if (isDataQualityEnabled && items?.length && !isImpersonateMode) {
      return await this.router.navigate(['data-quality-check'])
    }
    return true
  }
}
